import { render, staticRenderFns } from "./RefundType.vue?vue&type=template&id=97c4cede&scoped=true&"
import script from "./RefundType.vue?vue&type=script&lang=js&"
export * from "./RefundType.vue?vue&type=script&lang=js&"
import style0 from "./RefundType.vue?vue&type=style&index=0&id=97c4cede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c4cede",
  null
  
)

export default component.exports